<template>
<div class="chapter">
<div class="inner_page">
<p class="center titletop"><span class="textStyle2">To Nicolas and Julia</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FrontOther01.vue?c75df14a